<template>
  <div>
    <defaultImg class="banner" :src="require('@/assets/images/image63.png')"></defaultImg>
    <div class="content">
        <div class="box1">
          <div class="typeArea">
            <breadcrumb class="breadcrumb"></breadcrumb>
            <div class="box-title">员工发展·携手共赢</div>
            <div class="box1-content">
              <div class="box1-content-item" @mouseenter="iconList.img1=require('@/assets/images/image68.png')" @mouseleave="iconList.img1=require('@/assets/images/image65.png')">
                <img :src="iconList.img1" alt="">
                <div class="box1-content-item-title">员工成长</div>
                <div class="box1-content-item-line">公司核心人才选拔·认定年度职级</div>
                <div class="box1-content-item-line">薪级晋升·内外部专业技术提升培训</div>
                <div class="box1-content-item-line">个人学历、职业技能提升补贴</div>
              </div>
              <div class="box1-content-item" @mouseenter="iconList.img2=require('@/assets/images/image69.png')" @mouseleave="iconList.img2=require('@/assets/images/image66.png')">
                <img :src="iconList.img2" alt="">
                <div class="box1-content-item-title">员工福利</div>
                <div class="box1-content-item-line">弹性工作制（自主调休）·六险（五险+商业保险）一金</div>
                <div class="box1-content-item-line">免费年度体检·红白喜事慰问津贴</div>
                <div class="box1-content-item-line">生日、节假日津贴·季度部门团建津贴</div>
              </div>
              <div class="box1-content-item" @mouseenter="iconList.img3=require('@/assets/images/image70.png')" @mouseleave="iconList.img3=require('@/assets/images/image67.png')">
                <img :src="iconList.img3" alt="">
                <div class="box1-content-item-title">员工假期</div>
                <div class="box1-content-item-line">法定假期及双休</div>
                <div class="box1-content-item-line">带薪年假（5-15天）·3.8女神节假（0.5天）</div>
                <div class="box1-content-item-line">6.1亲子陪伴假（0.5天）·七夕单身贵族假（0.5天）</div>
              </div>
            </div>
          </div>
        </div>
        <div class="box2 typeArea">
          <div class="box-title">加入健安德·开启不可思议的历程</div>
          <div class="box2-describe">
            <div>招聘类型</div>
            <div>岗位名称</div>
            <div>岗位部门</div>
            <div>办公地点</div>
            <div>职位详情</div>
          </div>
          <div class="box2-item" :class="showItem.includes(1)?'box2-item-active':'box2-item-default'">
            <div class="box2-item-title" @click="changeItem(1)">
              <div>社招岗位</div>
              <div>试验人员</div>
              <div>分析试验部</div>
              <div>贵州·贵阳</div>
              <div>查看职位</div>
            </div>
            <div class="box2-item-content">
              <img  class="box2-item-split" src="@/assets/images/image71.png" alt="">
              <div class="box2-item-content-item">
                <div class="box2-item-content-title">岗位薪资：</div>
                <ul>
                  <li>
                    本科：<span>4-7K</span>/月
                  </li>
                  <li>
                    研究生：<span>5.5-9K</span>/月
                  </li>
                  <li>
                    <div>研究生不限院校。</div>
                  </li>
                </ul>
              </div>
              <div class="box2-item-content-item marginLeft50">
                <div class="box2-item-content-title">岗位描述：</div>
                <div class="box2-item-content-common">1、 认同公司文化；</div>
                <div class="box2-item-content-common">2、 按时按计划完成项目负责人安排的试验项目；</div>
                <div class="box2-item-content-common">3、 配合组内其他人员完成组内试验项目；</div>
                <div class="box2-item-content-common">4、 配合部门完成部门内部日常管理工作。</div>
              </div>
              <div class="box2-item-content-item marginLeft50">
                <div class="box2-item-content-title">任职说明和要求：</div>
                <div class="box2-item-content-common">1、需求专业：应用化学、分析化学等；</div>
                <div class="box2-item-content-common">2、能够熟悉操作相关分析仪器，如液相色谱仪、气相色谱仪等；</div>
                <div class="box2-item-content-common">3、能够独立管理自己的试验项目；</div>
                <div class="box2-item-content-common">4、能够认真负责地填写相关试验记录，按时保质保量提交原始记录。</div>
              </div>
              <div class="sendMail">
                <span>发送简历至邮箱（请备注要面试的岗位）</span>
                <span>jiandee@jiandee.com</span>
              </div>
            </div>
          </div>
          <div class="box2-item" :class="showItem.includes(2)?'box2-item-active':'box2-item-default'">
            <div class="box2-item-title" @click="changeItem(2)">
              <div>社招岗位</div>
              <div>储备QA</div>
              <div>质量保证部</div>
              <div>贵州·贵阳</div>
              <div>查看职位</div>
            </div>
            <div class="box2-item-content">
              <img  class="box2-item-split" src="@/assets/images/image71.png" alt="">
              <div class="box2-item-content-item">
                <div class="box2-item-content-title">岗位薪资：</div>
                <ul>
                  <li>
                    本科：<span>4-7K</span>/月
                  </li>
                  <li>
                    研究生：<span>5.5-9K</span>/月
                  </li>
                  <li>
                    <div>研究生不限院校。</div>
                  </li>
                </ul>
              </div>
              <div class="box2-item-content-item marginLeft50">
                <div class="box2-item-content-title">岗位描述：</div>
                <div class="box2-item-content-common">1、 认同公司文化；</div>
                <div class="box2-item-content-common">2、 CMA、CNAS、GLP体系的运行，持续改进内审、</div>
                <div class="box2-item-content-common">&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp设施检查、报告审核等质量保证工作:</div>
              </div>
              <div class="box2-item-content-item marginLeft50">
                <div class="box2-item-content-title">任职说明和要求：</div>
                <div class="box2-item-content-common">1、需求专业：化学、药学、生物、食品、环境科学等；</div>
                <div class="box2-item-content-common">2、本科及以上学历，研究生优先:</div>
                <div class="box2-item-content-common">3、良好的沟通能力，较好的电脑办公基础</div>
              </div>
              <div class="sendMail">
                <span>发送简历至邮箱（请备注要面试的岗位）</span>
                <span>jiandee@jiandee.com</span>
              </div>
            </div>
          </div>
          <div class="box2-item" :class="showItem.includes(3)?'box2-item-active':'box2-item-default'">
            <div class="box2-item-title" @click="changeItem(3)">
              <div>社招岗位</div>
              <div>动物试验技术人员</div>
              <div>设施管理部</div>
              <div>贵州·贵阳</div>
              <div>查看职位</div>
            </div>
            <div class="box2-item-content">
              <img  class="box2-item-split" src="@/assets/images/image71.png" alt="">
              <div class="box2-item-content-item">
                <div class="box2-item-content-title">岗位薪资：</div>
                <ul>
                  <li>
                    本科：<span>4-7K</span>/月
                  </li>
                  <li>
                    研究生：<span>5.5-9K</span>/月
                  </li>
                  <li>
                    <div>研究生不限院校。</div>
                  </li>
                </ul>
              </div>
              <div class="box2-item-content-item marginLeft50">
                <div class="box2-item-content-title">岗位描述：</div>
                <div class="box2-item-content-common">1、认同公司文化；</div>
                <div class="box2-item-content-common">2、要求执行力强，认同设施管理部门工作流程，责任心强，具有团队合作精神，愿意付出;</div>
                <div class="box2-item-content-common">3、据试验计划书、试验表格、试验流程等要求完成试验，及时、清晰、完整地记录:</div>
                <div class="box2-item-content-common">4、根据安排完成受试生物体系的维护和饲养:</div>
                <div class="box2-item-content-common">5、根据管理规定，负责仪器维护.期间核查、检定/校准等。</div>

              </div>
              <div class="box2-item-content-item marginLeft50">
                <div class="box2-item-content-title">任职说明和要求：</div>
                <div class="box2-item-content-common">1、需求专业：药学、动物医学、医学相关专业</div>
                <div class="box2-item-content-common">2、沟通能力强、有上进心，具有团队意识，</div>
                <div class="box2-item-content-common">&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp能够服从部门安排，能接受一定程度的加班。</div>
              </div>
              <div class="sendMail">
                <span>发送简历至邮箱（请备注要面试的岗位）</span>
                <span>jiandee@jiandee.com</span>
              </div>
            </div>
          </div>
          <div class="box2-item" :class="showItem.includes(4)?'box2-item-active':'box2-item-default'">
            <div class="box2-item-title" @click="changeItem(4)">
              <div>社招岗位</div>
              <div>试验人员</div>
              <div>环境影响部</div>
              <div>贵州·贵阳</div>
              <div>查看职位</div>
            </div>
            <div class="box2-item-content">
              <img  class="box2-item-split" src="@/assets/images/image71.png" alt="">
              <div class="box2-item-content-item">
                <div class="box2-item-content-title">岗位薪资：</div>
                <ul>
                  <li>
                    本科：<span>4-7K</span>/月
                  </li>
                  <li>
                    研究生：<span>5.5-9K</span>/月
                  </li>
                  <li>
                    <div>研究生不限院校。</div>
                  </li>
                </ul>
              </div>
              <div class="box2-item-content-item marginLeft50">
                <div class="box2-item-content-title">岗位描述：</div>
                <div class="box2-item-content-common">1、认同公司文化；</div>
                <div class="box2-item-content-common">2、要求执行力强，认同设施管理部门工作流程，责任心强，具有团队合作精神，愿意付出;</div>
                <div class="box2-item-content-common">3、按时有计划完成项目负责人安排的试验项目，及时、清晰、完整地记录原始记录:</div>
                <div class="box2-item-content-common">4、服从安排完成受试生物体系的维护和饲养;</div>
                <div class="box2-item-content-common">5、根据管理规定，负责仪器维护、期间核查、检定/校准等。</div>

              </div>
              <div class="box2-item-content-item marginLeft50">
                <div class="box2-item-content-title">任职说明和要求：</div>
                <div class="box2-item-content-common">1、需求专业：生物、农学、环境等相关专业</div>
                <div class="box2-item-content-common">2、沟通能力强、有上进心，具有团队意识，</div>
                <div class="box2-item-content-common">&nbsp&nbsp&nbsp&nbsp&nbsp能够服从部门安排</div>
              </div>
              <div class="sendMail">
                <span>发送简历至邮箱（请备注要面试的岗位）</span>
                <span>jiandee@jiandee.com</span>
              </div>
            </div>
          </div>
        </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'joinUs',
  data () {
    return {
      iconList:{
        img1: require("@/assets/images/image65.png"),
        img2: require("@/assets/images/image66.png"),
        img3: require("@/assets/images/image67.png"),
      },
      showItem:[]
    }
  },
  methods: {
    changeItem(item){
      if(this.showItem.includes(item)){
        this.showItem.splice(this.showItem.indexOf(item),1)
      }else{
        this.showItem.push(item)
      }
    }
  },
}
</script> 

<style lang='less' scoped>
    .banner{
        height: 600px;
        width: 100%;
        object-fit: cover;
    }
    .content{
      .breadcrumb{
          margin: 40px 0 70px 0;
      }
      .box-title{
        text-align: center;
        color: #333333;
        font-size: 32px;
        font-weight: bold;
      }
      .box1{
        width: 100%;
        height: 572px;
        background: url("../../assets/images/image64.png");
        .box1-content{
          margin-top: 40px;
          display: flex;
          justify-content: space-between;
          .box1-content-item:hover{
            background-color: #DB0000;
            .box1-content-item-title{
              color: #ffffff;
            }
            .box1-content-item-line{
              color: #ffffff;
            }
          }
          .box1-content-item{
            height: 300px;
            width: 460px;
            background-color: #fff;
            border-radius: 15px;
            box-shadow: 0px 3px 5px 1px rgb(171, 171, 171);
            padding-top: 45px;
            box-sizing: border-box;
            img{
              position: relative;
              left: 50%;
              transform: translateX(-50%);
            }
            .box1-content-item-title{
              color: #DB0000;
              text-align: center;
              font-weight: bold;
              font-size: 28px;
              margin-bottom: 14px;
            }
            .box1-content-item-line{
              text-align: center;
              font-size: 14px;
              color: #333333;
              margin-top: 3px;
            }
          }
        }
      }
      .box2{
        padding: 40px 0 80px 0;
        .box2-describe{
          color: #666666;
          margin-top: 80px;
          overflow: hidden;
          div{
            width: 288px;
            float: left;
            text-align: center;
          }
        }
        .box2-item-default{
          max-height: 55px;
        }
        .box2-item-active{
          max-height: 550px;
          .box2-item-title{
            div{
              color: #DB0000 !important;
            }
            div:nth-child(5)::after{
              transform: rotate(90deg) translateX(-25%) !important;
            }
          }
        }
        .box2-item{
          background-color: #F6F6F6;
          margin-top: 20px;
          overflow: hidden;
          padding: 17px 0;
          border-radius: 15px;
          box-sizing: border-box;
          transition: .5s all ease;
          .box2-item-title{
            cursor: pointer;
            div{
              width: 288px;
              float: left;
              text-align: center;
              color: #333333;
              position: relative;
              transition: .3s all ease;
              &:nth-child(2),&:nth-child(5){
                font-weight: bold;
              }
            }
            div:nth-child(5)::after{
              content: "";
              position: absolute;
              top: 50%;
              transform: translateY(-50%);
              left: 63%;
              display: block;
              background: url("../../assets/images/image72.png");
              height: 10px;
              width: 10px;
              background-repeat: no-repeat;
            }
          }
          .box2-item-content{
            padding: 0 50px;
            .box2-item-split{
              margin: 30px auto;
              position: relative;
              left: 50%;
              transform: translateX(-50%);
            }
            .box2-item-content-title{
              font-weight: bold;
            }
            .marginLeft50{
              margin-left: 50px;
            }
            .box2-item-content-item{
              font-size: 14px;
              float: left;
              ul{
                li{
                  color: #333333;
                  list-style: disc;
                  margin-left: 18px;
                  margin-top: 5px;
                  &::marker{
                      color: #DB0000;
                  }
                  span{
                    color: #DB0000;
                    font-size: 26px;
                    font-weight: bold;
                  }
                }
              }
              .box2-item-content-common{
                margin-top: 8px;
              }
            }
            .sendMail{
              width: 100%;
              float: left;
              margin-top: 23px;
              font-weight: bold;
              &>span:first-child{
                color: #333333;
                font-size: 15px;
              }
              &>span:last-child{
                color: #DB0000;
                font-size: 18px;
              }
            }
          }
        }
      }
    }
</style>
